import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import Loading from './Loading'

export default function RotaProtegida() {
  const { utilizador, perfil, carregando } = useAuth()

  if (carregando) return <Loading />
  if (!utilizador) return <Navigate to="/admin/login" replace />
  if (perfil?.forcar_mudanca_password) return <Navigate to="/admin/alterar-password" replace />

  return <Outlet />
}
